/*
 * /therapy/session/slug (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import {
	Button,
	Container,
	Divider,
	Page,
	PageHeader,
} from "@psychology/react-ui"
import { capitalizeFirstLetter } from "@psychology/utils"
import { ArrowLeft } from "lucide-react"
import { trpc } from "../../../trpc"
import { authPageLoader } from "../../../utils/auth.utils"
// import { TherapySessionForm } from "../../../features/therapy/components/therapy-session-form"

export const Route = createFileRoute("/therapy/session/$therapySessionId")({
	component: TherapySessionPage,
	loader: authPageLoader,
})

function TherapySessionPage() {
	// const { user } = Route.useLoaderData()
	const { therapySessionId } = Route.useParams()

	const {
		data: therapySession,
		isLoading,
		refetch,
	} = trpc.therapySession.getByFilter.useQuery({
		where: { id: therapySessionId },
	})

	if (isLoading) {
		return (
			<Page centerVertical={true}>
				<Container width={"xl"} padding={"lg"}>
					<div className={"text-center"}>{"Loading..."}</div>
				</Container>
			</Page>
		)
	} else if (!therapySession) {
		return (
			<Page centerVertical={true}>
				<Container width={"xl"} padding={"lg"}>
					<div className={"text-center"}>
						{"Failed to load Therapy Session"}
					</div>
					<Button variant={"default"} onClick={() => refetch()}>
						Retry
					</Button>
				</Container>
			</Page>
		)
	}

	return (
		<Page centerVertical={false}>
			<Container
				className={"items-center"}
				width={"xl"}
				padding={"lg"}
				gap={"sm"}
			>
				<PageHeader
					title={capitalizeFirstLetter(
						therapySession?.title || "New Therapy Session",
						true,
					)}
					left={{
						href: "/therapy/session",
						label: "Back",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				<div className={"w-full py-6"}>
					{/* <TherapySessionForm
						defaultValues={therapySession || { userId: user.id }}
						childrenOnExisting={
							<TherapyReminderListServer
								className={"w-full"}
								therapySessionId={therapySessionId}
								userId={user.id}
							/>
						}
					/> */}
				</div>
			</Container>
		</Page>
	)
}
